<template>
    <div class="reservation_single" v-if="!isFetching">
        <div class="reservation_single-back">
            <div class="reservation_single-back--btn" @click="this.$router.go(-1)">
                <div class="icon">
                    <img src="../assets/img/back.svg">
                </div>
                <div class="text">
                    Назад
                </div>
            </div>

        </div>
        <div class="reservation_single-content">
            <div class="reservation_single-content--header">
                <div class="reservation_single-content--title">
                    {{ this.reservation.training_name }}
                </div>

                <template v-if="+this.reservation.cancel">
                    <p class="reservation_item--status canceled">
                      Занятие отменено
                    </p>
                </template>

                <div v-else class="reservation_single-content--status" :class="'reservation_single-content--status-' + this.reservation.status">
                    {{ eventStatus }}
                </div>

                <div class="reservation_single-content--params">
                    <div class="reservation_single-content--date">
                        <ul class="list-style-dot">
                            <li>{{ eventTimeStart }} - {{ eventTimeEnd }}</li>
                            <li>{{ eventDate }}</li>
                        </ul>
                    </div>
                    <div class="reservation_single-content--meta">
                        <ul class="list-style-dot">
                            <li>{{ eventType }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="reservation_single-content--data">
                <div class="row">
                    <div v-if="hasTrainer" class="col-lg-6">
                        <div class="reservation_single-content--data_block reservation_single-content--trainer">
                            <div class="img">
                                <img :src="eventTrainerPhotoUrl" :alt="eventTrainerName" onerror="this.parentElement.style.display='none'">
                            </div>
                            <div class="name">
                                {{ eventTrainerName }}
                                <div class="position">
                                    {{ eventTrainerPosition }}
                                </div>
                            </div>
                            <div class="rating">
                                <i><img src="../assets/img/star.svg"></i> <span>{{ eventTrainerRating }}</span>
                            </div>
                        </div>
                    </div>
                    <div :class="hasTrainer ? 'col-lg-6' : 'col-lg-12'">
                        <div class="reservation_single-content--data_block reservation_single-content--place">
                            <i>
                                <img src="../assets/img/gantel.svg">
                            </i>
                            {{ this.reservation.place_name }}
                        </div>
                    </div>
                    <div class="col-lg-12" v-if="this.eventGroup !== null">
                        <div class="reservation_single-content--data_block reservation_single-content--icons">
                            <ul>

                                <li v-if="this.eventGroup.payed === 'pay'">
                                    <div class="reservation_single-content--icon">
                                        <div class="icon">
                                            <img src="../assets/img/money.png">
                                        </div>
                                        <div class="text">
                                            Платное
                                        </div>
                                    </div>
                                </li>

                                <li v-if="this.eventGroup.type === 'kids'">
                                    <div class="reservation_single-content--icon">
                                        <div class="icon">
                                            <img src="../assets/img/kids.png">
                                        </div>
                                        <div class="text">
                                            Детское
                                        </div>
                                    </div>
                                </li>

                                <li v-if="this.eventGroup.transfer_event !== null && this.eventGroup.transfer_event !== undefined">
                                    <div class="reservation_single-content--icon">
                                        <div class="icon">
                                            <img src="../assets/img/transfer.png">
                                        </div>
                                        <div class="text">
                                            Перенесено
                                        </div>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="reservation_single-content--description">
                {{ this.reservation.description }}
            </div>

            <div class="reservation_single-content--action" v-if="!isEventFinished">
                <div class="error_msg" v-if="errorMessage">
                  {{ errorMessage }}
                </div>

                <div
                    class="btn btn-white"
                    :class="{disabled: isDisabledBtn}"
                    @click="cancelReservation"
                    v-if="!isReservationCanceled && !errorMessage"
                >
                    Отменить запись
                </div>

                <div
                    class="btn"
                    :class="{disabled: isDisabledBtn}"
                    @click="addReservation"
                    v-if="this.eventGroup !== null && isReservationCanceled && this.reservation.type !== 'personal' && !errorMessage"
                >
                    Записаться на тренировку
                </div>
            </div>
        </div>
    </div>

    <rent-cancellation-flow-modal
        v-if="cancelFlowStep"
        :step="cancelFlowStep"
        :confirm-text="cancelConfirmText"
        :loading-text="cancelLoadingText"
        :success-text="cancelSuccessText"
        :error-text="cancelErrorText"
        @close="closeCancelFlow"
        @confirm="submitRentCancellation"
    />

</template>

<script>
    import api from "../api";
    import moment from "moment";
    import RentCancellationFlowModal from '../components/RentCancellationFlowModal.vue'
    import { getReservationTrainer, getReservationTypeLabel, getTrainerDisplayName } from "../utilities";

    export default {
        name: 'ReservationSingle',
        components: { RentCancellationFlowModal },
        data() {
            return {
                errorMessage: '',
                reservation: null,
                eventGroup: null,
                trainer: null,
                isFetching: true,
                isDisabledBtn:false,
                cancelFlowStep: null,
                cancelErrorText: '',
                cancellationResult: null,
            }
        },
        computed: {
            eventType: function () {
                return getReservationTypeLabel(this.reservation.type)
            },
            eventTrainer: function () {
                return getReservationTrainer(this.reservation.type, this.eventGroup?.trainer_replacement, this.trainer)
            },
            hasTrainer: function () {
                return !!this.eventTrainer
            },
            eventTrainerName: function () {
                return getTrainerDisplayName(this.eventTrainer)
            },
            eventTrainerPhotoUrl: function (){
                return this.eventTrainer?.photo || ''
            },
            eventTrainerPosition: function() {
                return this.eventTrainer?.function || ''
            },
            eventTrainerRating: function () {
                return this.eventTrainer?.rating || ''
            },
            eventDate: function () {
                return moment(this.reservation.date, 'YYYY-MM-DD').format('dd, D MMMM ');
            },
            eventTimeStart: function () {
                return moment(this.reservation.start, 'HH:mm:ss').format('HH:mm');
            },
            eventTimeEnd: function () {
                return moment(this.reservation.end, 'HH:mm:ss').format('HH:mm');
            },
            eventStatus: function () {
                let status = '';

                switch (Number(this.reservation.status)) {
                    case 0:
                        status = 'Вы записаны'
                        break;
                    case 1:
                        status = 'Вы записаны'
                        break;
                    case 2:
                        status = 'Отказался'
                        break;
                    case 3:
                        status = 'Занятие завершено'
                        break;
                    case 4:
                        status = 'Занятие пропущено'
                        break;
                    case 5:
                        status = 'Поздняя отмена'
                        break;
                    case 7:
                        status = this.reservation.status_label;
                        break;
                    default:
                        status = 'Неизвестно'
                }

                return status
            },
            isEventFinished: function(){
                return moment(this.reservation.date + ' ' + this.reservation.start).isBefore()
            },
            isReservationCanceled: function(){
                return (this.reservation.status === 2 || this.reservation.status === 5)
            },
            isRentReservation: function () {
                return this.reservation?.type === 'rent'
            },
            cancellationRules: function () {
                return this.reservation?.cancellation_rules || {}
            },
            hasRefundOnCancellation: function () {
                return this.cancellationRules.consequence === 'refund'
            },
            isOnlinePayment: function () {
                return this.reservation?.payment_type === 'online'
            },
            isLateRentCancellation: function () {
                return this.cancellationRules.type === 'late'
                    || this.cancellationRules.consequence === 'service_writeoff'
            },
            cancellationRefund: function () {
                return this.cancellationResult?.refund || null
            },
            isOnlineRefundCompleted: function () {
                return this.cancellationRefund?.type === 'online'
                    && this.cancellationRefund?.status === 'completed'
            },
            cancelConfirmText: function () {
                if (this.isLateRentCancellation) return ''
                if (!this.isOnlinePayment) return 'За возвратом денежных средств обратитесь в клуб'
                return this.hasRefundOnCancellation
                    ? 'После отмены брони деньги поступят на счет, с\u00A0которого была произведена оплата'
                    : ''
            },
            cancelLoadingText: function () {
                return this.hasRefundOnCancellation && this.isOnlinePayment
                    ? 'Бронь отменяется. Производим возврат средств'
                    : 'Бронь отменяется'
            },
            cancelSuccessText: function () {
                if (this.isLateRentCancellation) return ''
                if (this.isOnlineRefundCompleted) {
                    return 'Возврат средств успешно выполнен. Деньги поступят на карту, с которой была произведена оплата'
                }
                if (this.cancellationRefund?.type === 'offline') {
                    return 'За возвратом денежных средств обратитесь в клуб'
                }
                if (!this.isOnlinePayment) return 'За возвратом денежных средств обратитесь в клуб'
                return ''
            }
        },
        methods: {
            async loadEvent(){
                try {
                    this.$store.commit('SHOW_PRELOADER')
                    this.reservation = (await api.schedule.getReservation(this.$route.params.id)).data;

                    const trainerPromise = this.reservation.trainer !== null && this.reservation.trainer !== undefined
                        ? api.schedule.getTrainer(this.reservation.trainer)
                        : Promise.resolve({ data: null })
                    const schedulePromise = this.reservation.schedule_id !== null && this.reservation.schedule_id !== undefined
                        ? api.schedule.getSchedule(this.reservation.schedule_id)
                        : Promise.resolve({ data: null })

                    const [trainerResponse, scheduleResponse] = await Promise.all([trainerPromise, schedulePromise])

                    this.trainer = trainerResponse.data
                    this.eventGroup = scheduleResponse.data
                    this.$store.commit('HIDE_PRELOADER')
                    this.isFetching = false
                }catch (e) {
                    console.log(e)
                    alert('Ошибка загрузки. Попробуйте еще раз.')
                    this.$store.commit('HIDE_PRELOADER')
                    this.isFetching = false
                }
                this.isDisabledBtn = false;
            },
            async cancelReservation() {
              if (this.isRentReservation) {
                if (this.isDisabledBtn) return
                await this.startRentCancellation()
                return
              }

              try {
                this.isDisabledBtn = true;
                this.errorMessage = '';
                const result = (await api.schedule.deleteSchedule(this.reservation.id)).data;

                if (result.status == 'success') {
                  this.loadEvent()
                  this.$store.dispatch('loadReservations')
                }
              } catch (e) {
                if (e.response?.status === 400 && e.response.data?.message) {
                  this.errorMessage = e.response.data.message;
                } else {
                  console.error('Произошла ошибка при отмене тренировки');
                }
              } finally {
                this.isDisabledBtn = false;
              }
            },
            async startRentCancellation() {
              try {
                this.isDisabledBtn = true;
                this.errorMessage = '';
                this.cancellationResult = null;
                this.reservation = (await api.schedule.getReservation(this.reservation.id)).data;

                if (this.cancellationRules.is_late_cancel_forbidden === true) {
                  this.errorMessage = `До занятия осталось меньше ${this.formatLateCancelLimit(this.cancellationRules.late_cancel_time_minutes)}, отменить его не получится`;
                  return
                }

                this.cancelFlowStep = this.cancellationRules.requires_confirmation === true
                    ? 'late-cancel'
                    : 'confirm'
              } catch (e) {
                this.cancelErrorText = e.response?.data?.message || this.getCancellationErrorMessage()
                this.cancelFlowStep = 'error'
              } finally {
                this.isDisabledBtn = false;
              }
            },
            async submitRentCancellation() {
              if (this.cancelFlowStep === 'loading') return
              this.cancelFlowStep = 'loading'

              try {
                this.isDisabledBtn = true;
                this.errorMessage = '';
                const result = (await api.schedule.deleteSchedule(this.reservation.id)).data;

                if (result.status !== 'success') {
                  this.cancelErrorText = result.message || result.error || this.getCancellationErrorMessage()
                  this.cancelFlowStep = 'error'
                  return
                }

                this.cancellationResult = result
                this.cancelFlowStep = 'success'
              } catch (e) {
                this.cancelErrorText = e.response?.data?.message
                    || e.response?.data?.error
                    || this.getCancellationErrorMessage()
                this.cancelFlowStep = 'error'
              } finally {
                this.isDisabledBtn = false;
              }
            },
            async closeCancelFlow() {
              if (this.cancelFlowStep === 'loading') return
              const wasSuccess = this.cancelFlowStep === 'success'
              this.cancelFlowStep = null

              if (wasSuccess) {
                await this.loadEvent()
                await this.$store.dispatch('loadReservations')
              }
            },
            getCancellationErrorMessage() {
              return this.hasRefundOnCancellation
                  ? 'Во время отмены брони и возврата средств произошла ошибка. Пожалуйста, обратитесь к\u00A0администратору клуба'
                  : 'Во время отмены брони произошла ошибка. Пожалуйста, обратитесь к\u00A0администратору клуба'
            },
            formatLateCancelLimit(minutes) {
              const value = Number(minutes)
              if (!Number.isFinite(value) || value <= 0) return '0 минут'
              if (value % 60 !== 0) return `${value} ${this.pluralize(value, ['минуту', 'минуты', 'минут'])}`
              const hours = value / 60
              return `${hours} ${this.pluralize(hours, ['час', 'часа', 'часов'])}`
            },
            pluralize(value, forms) {
              const absolute = Math.abs(value) % 100
              const lastDigit = absolute % 10
              if (absolute > 10 && absolute < 20) return forms[2]
              if (lastDigit > 1 && lastDigit < 5) return forms[1]
              if (lastDigit === 1) return forms[0]
              return forms[2]
            },
            async addReservation(){
              try {
                this.isDisabledBtn = true;
                const result = (await api.schedule.postSchedule(this.reservation.schedule_id)).data;

                if (result.status == 'success' || result.status == 'waiting') {
                  this.loadEvent()
                  this.$store.dispatch('loadReservations')
                }
              } catch (e) {
                if (e.response?.status === 400 && e.response.data?.message) {
                  this.errorMessage = e.response.data.message;
                } else {
                  this.errorMessage = 'Произошла ошибка при записи на тренировку';
                }
              } finally {
                this.isDisabledBtn = false;
              }
            },
            goToShopSchedule() {
              let scheduleId = this.reservation.schedule_id;
              this.$router.push(`/shop/schedule/${scheduleId}`);
            },
        },
        beforeCreate() {

        },
        created() {
            this.loadEvent()
        },
        mounted() {

        }
    }
</script>

<style scoped>
.error_msg {
  color: #FA2E69;
  font-size: 16px;
  margin-bottom: 4px;
}
</style>
